<!-- 图片识别中-->
<template>
  <div class="identify">
    <img src="https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-task-mini/identify.gif" alt="" />
    <p class="waiting">图片识别中...</p>
    <div class="time">{{ timeCount }}s</div>
    <DrawCardNumberPop :onNumberShow="onNumberShow" @showNumberFn="showNumberFn" />
    <NoidentyPop @changeShow="changeShow" :onShow="onShow" />
  </div>
</template>

<script>
import DrawCardNumberPop from '../component/drawCardNumberPop';
import NoidentyPop from '../component/noidentyPop';
import { reqImageRecognition, reqActivityDoneTask } from '@/api/collectCard/index';
export default {
  components: {
    DrawCardNumberPop,
    NoidentyPop,
  },
  data() {
    return {
      timeCount: 30,
      timer: null,
      onShow: false,
      onNumberShow: false,
      cardActiveId: this.$route.query.cardActiveId,
      cardTaskId: this.$route.query.cardTaskId,
    };
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
  },

  computed: {},
  watch: {},

  created() {},
  mounted() {
    this.startTime();
    this.identying();
  },
  methods: {
    async addCount() {
      if (this.cardActiveId && this.cardTaskId) {
        const { code, msg } = await reqActivityDoneTask({
          cardActivityId: this.cardActiveId,
          cardTaskId: this.cardTaskId,
        });
        if (code === 0) {
          this.onShow = false;
          this.onNumberShow = true;
        } else {
          this.$toast(msg);
          setTimeout(() => {
            location.reload();
          }, 1000);
        }
      }
    },
    identying() {
      reqImageRecognition(this.fileList[0])
        .then((res) => {
          const { data } = res;
          clearInterval(this.timer);
          this.timeCount = 30;
          if (data) {
            this.addCount();
          } else {
            this.onShow = true;
            this.onNumberShow = false;
          }
        })
        .catch(() => {
          this.onShow = true;
          clearInterval(this.timer);
          this.timeCount = 30;
        });
    },

    startTime() {
      this.timer = setInterval(() => {
        this.timeCount--;
        if (this.timeCount <= 1) {
          clearInterval(this.timer);
          this.onShow = true;
        }
      }, 1000);
    },
    //识别成功获得抽卡机会弹窗
    showNumberFn() {
      this.onNumberShow = false;
      this.$router.push('/collectCardIndex');
    },
    //未识别到弹窗
    changeShow() {
      this.onShow = false;
      window.location.reload();
    },
  },
};
</script>
<style lang="scss" scoped>
.identify {
  padding-top: 1px;
  img {
    display: block;
    margin: 200px auto 0;
  }
  .waiting {
    font-weight: 400;
    font-size: 29px;
    color: #333333;
    text-align: center;
  }
  .time {
    font-weight: 600;
    font-size: 33px;
    color: #ff7f41;
    text-align: center;
    margin-top: 20px;
  }
}
</style>
